<template>
	<v-card class="card-rounded pb-5 justify-center text-center mx-auto" style="padding-bottom: 50px" max-width="300" :height="detailed ? 'auto' : 330" :outlined="true">
		<v-card-text v-if="!detailed" class="pt-n2 mt-n2 justify-center text-center">
			<v-list-item-avatar v-if="!avatar" :width="80" :height="80" class="mr-0">
				<v-skeleton-loader type="image" :loading="true" :width="80" :height="80" align="center" justify="center"> </v-skeleton-loader>
			</v-list-item-avatar>

			<v-list-item-avatar v-if="avatar && avatar != 'no-avatar'" width="80" height="80" class="mr-0">
				<v-img :src="avatar"></v-img>
			</v-list-item-avatar>

			<v-list-item-avatar v-if="avatar && avatar === 'no-avatar'" width="80" height="80" class="mr-0">
				<v-img :src="no_avatar"></v-img>
			</v-list-item-avatar>
			<h2 class="pl-0 pr-0 pt-0 mt-0 pb-1">{{ locum.first_name }} {{ locum.last_name.charAt(0).toUpperCase() }}</h2>
			<p class="blue--text lighten-1 font-weight-bold pb-0 mb-1">{{ locum.profession }}</p>

			<div>
				<small class="mt-1">
					<strong>Location:</strong>
					{{ locumAddress }}
				</small>
			</div>
			<div>
				<small class="mt-1">
					<strong>Experience:</strong>
					{{ experienceText }}
				</small>
			</div>
			<div>
				<small class="mt-1">
					<strong>Rates:</strong>
					{{ rateText }}
				</small>
			</div>
		</v-card-text>

		<v-card-actions v-if="!viewOnly" class="justify-center text-center pt-0 mt-0 mb-5 pb-5">
			<v-btn
				class="button-rounded continue-signup-button"
				style="position: absolute; bottom: 18px; text-transform: none !important"
				min-width="80%"
				color="#63c467"
				@click="onQuickbookLocum"
				><small style="font-size: 10px">Send booking request</small></v-btn
			>
		</v-card-actions>
	</v-card>
</template>

<script>
import store from '@/store';
import axios from 'axios';
import moment from 'moment';
import { Tracking } from '@/utils/tracking';

export default {
	name: 'FeaturedLocumCard',
	components: {},
	props: {
		locum: Object,
		reloadImage: Number,
		locumIndex: Number,
		viewOnly: { type: Boolean, default: false },
		detailed: { type: Boolean, default: false },
	},
	data: () => ({
		avatar: null,
		no_avatar: require('@/assets/images/avatars/user.png'),
	}),
	computed: {
		computed_avatar() {
			return this.avatar;
		},
		locumAddress() {
			if (this.locum.address.region && this.locum.address.suburb) {
				return this.locum.address.region + ', ' + this.locum.address.suburb;
			} else if (this.locum.address.region && !this.locum.address.suburb) {
				return this.locum.address.region;
			} else if (!this.locum.address.region && this.locum.address.suburb) {
				return this.locum.address.suburb;
			}
			return 'unknown address';
		},
		yearsExperience() {
			return 'experience' in this.locum ? moment().diff(this.locum.experience.start_date, 'years') : 0;
		},
		experienceText() {
			return this.yearsExperience > 0 ? this.yearsExperience.toString() + ' year' + (this.yearsExperience > 1 ? 's' : '') + ' experience' : 'Unknown experience';
		},
		locumInstitution() {
			let result = 'qualifications' in this.locum && 'institution' in this.locum.qualifications ? this.locum.qualifications.institution : 'false';
			switch (result.toLowerCase()) {
				case 'false':
					result = false;
					break;
				case 'uct':
					result = 'University of Cape Town';
					break;
				default:
					result = this.locum.qualifications.institution;
					break;
			}
			return result;
		},
		rateText() {
			const noRatesText = 'Rates not given';
			if (this.locum && this.locum.working_hours) {
				const ratesArray = Object.values(this.locum.working_hours).map(({ rate }) => Number(rate));
				if (ratesArray.length === 0) {
					return noRatesText;
				}
				const min = Math.min(...ratesArray);
				const max = Math.max(...ratesArray);
				return `R${min} to R${max}`;
			} else {
				return noRatesText;
			}
		},
	},
	watch: {
		reloadImage: function () {
			this.loadLocumImage();
		},
	},
	async mounted() {
		this.loadLocumImage();
	},
	methods: {
		onQuickbookLocum() {
			this.$emit('dismiss-featured-popup');
			this.$emit('clicked', { locum: this.locum, index: this.locumIndex });
			Tracking.track('Prac_LocumDirectory_Book');
		},
		loadLocumImage() {
			this.avatar = null;
			const token = store.getters.jwtToken;
			axios
				.get(store.getters.getDOCUMENTS + '/images/avatar/' + this.locum.id, { headers: { Authorization: token } })
				.then(response => {
					this.avatar = 'data:image/png;base64,' + response.data.data;
					this.$emit('avatar-changed');
				})
				.catch(() => {
					this.avatar = 'no-avatar';
					this.$emit('avatar-changed');
				});
		},
	},
};
</script>
